import { useQuery } from "@graphcommerce/graphql"
import { ProductListDocument, useProductListParamsContext } from "@graphcommerce/magento-product"
import { useEffect, useState } from "react";
import { CategoryPageQuery } from "../../graphql/CategoryPage.gql";
import { ProductListItems } from "../ProductListItems";
import Loading from "../icons/Loading";


// eslint-disable-next-line import/no-default-export
export default function AjaxProducts(props: CategoryPageQuery['categories']['items'][0]) {
  const [products, setProducts] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataLoading, setDataLoading] = useState(false);
  const [isEnd, setIsEnd] = useState(false);
  const { params } = useProductListParamsContext();
  const { data, loading, error, refetch, } = useQuery(ProductListDocument, {
    skip: true,
    variables: {
      pageSize: 16,
      currentPage: currentPage + 1,
      filters: {
        ...params.filters, category_uid: {
          eq: props.uid
        }
      },
      search: params.search,
    }
  });


  useEffect(() => {
    const scrollEndHandler = () => {
      const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight

      if (window.scrollY >= scrollableHeight) {
        if (!dataLoading && !isEnd) {
          setDataLoading(true);
          refetch().then(({ data: { products } }) => {
            if (products) {
              setCurrentPage(() => products?.page_info?.current_page!);
              setProducts(olddata => [...olddata, ...(products?.items ?? [])]);
            }
          }).catch(err => setIsEnd(old => true)).finally(() => setDataLoading(false))
        }
      }
    }
    document.addEventListener('scroll', scrollEndHandler)
    return () => document.removeEventListener('scroll', scrollEndHandler);
  }, []);


  return (
    <div>
      <ProductListItems
        title=""
        items={products}
        loadingEager={1}
      />
      {dataLoading ? <span className="py-7 block text-center"><Loading width={36} height={36} /></span> : null}
      {isEnd ? <p className="text-sm text-default-900 text-center mt-5">محصول بیشتری وجود ندارد.</p> : null}

    </div>
  )
}